import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  TRANSLATION_GROUP_PAYMENT_SYSTEMS,
} from './constants';
import { getTranslationKeys } from './translations';

export class PaymentSystemsModule extends AppModule {
  addRoutes(): void {}

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_PAYMENT_SYSTEMS, getTranslationKeys);
  }
}
